import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api/client';
import { fieldLabelStyle } from '../lib/theme';
import AuthLayout, {
  authErrorStyle,
  authFieldStyle,
  authFormStyle,
  authSubmitStyle,
} from '../components/AuthLayout';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') ?? '';
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.post('/auth/reset-password', { token, newPassword });
      navigate('/login');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Reset failed');
    } finally {
      setSubmitting(false);
    }
  }

  if (!token) {
    return (
      <AuthLayout title="Reset password">
        <p style={{ opacity: 0.75, textAlign: 'center', margin: 0 }}>
          This link is missing a reset token. <Link to="/forgot-password">Request a new one</Link>.
        </p>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Reset password">
      <form onSubmit={handleSubmit} style={authFormStyle}>
        {error && <p style={authErrorStyle}>{error}</p>}

        <label style={fieldLabelStyle}>
          New password
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={8}
            style={authFieldStyle}
          />
        </label>

        <button type="submit" disabled={submitting} style={authSubmitStyle}>
          {submitting ? 'Saving…' : 'Set new password'}
        </button>
      </form>
    </AuthLayout>
  );
}
